// トップページ FV 順次出現シーケンス

/** <br> を境に行ごとの fx-intro-line 構造へ分解する */
function wrapLines(el) {
  if (!el) return [];

  const nodes = Array.from(el.childNodes);
  const groups = [];
  let current = [];

  nodes.forEach((node) => {
    if (node.nodeName === 'BR') {
      groups.push(current);
      current = [];
    } else {
      current.push(node);
    }
  });
  if (current.length) groups.push(current);

  el.innerHTML = '';

  return groups.map((lineNodes) => {
    const outer = document.createElement('span');
    outer.className = 'fx-intro-line';

    const inner = document.createElement('span');
    inner.className = 'fx-intro-line-inner';
    lineNodes.forEach((n) => inner.appendChild(n.cloneNode(true)));

    outer.appendChild(inner);
    el.appendChild(outer);
    return outer;
  });
}

/** 子ノードを丸ごと fx-intro-line-inner にラップして fx-intro-line を付与する */
function wrapIntroLine(el) {
  if (!el) return;
  const inner = document.createElement('span');
  inner.className = 'fx-intro-line-inner';
  while (el.firstChild) inner.appendChild(el.firstChild);
  el.appendChild(inner);
  el.classList.add('fx-intro-line');
}

/**
 * header の中身（ロゴ・ナビ・言語切替）を専用ラッパーへまとめ、
 * それに fx-intro-line を適用する。header 自体は高さ94remの箱で
 * 中身の行の高さよりずっと大きいため、直接マスクにすると隠れきらない。
 */
function wrapHeaderIntroLine(headerEl) {
  if (!headerEl) return null;
  const wrap = document.createElement('div');
  wrap.className = 'header-intro-wrap';
  while (headerEl.firstChild) wrap.appendChild(headerEl.firstChild);
  headerEl.appendChild(wrap);
  wrapIntroLine(wrap);
  return wrap;
}

/**
 * 右下コーナーを中心にした円弧で欠けた矩形の clip-path (path()) を返す。
 * R が W・H を超えても弧の端点が要素の外側に出るだけで、矩形内は正しく全欠けになる
 * ため上限クランプは不要（対角線 sqrt(W²+H²) 以上で全欠け）。
 * 固定辺（上端・左端・下端）は要素の外側へ1pxオーバースキャンし、
 * アンチエイリアシングによる縁のにじみを避ける。弧の端点（右辺・下辺上）はぴったり合わせる。
 */
function curlClipPath(W, H, R) {
  return `path("M -1 -1 L ${W + 1} -1 L ${W} ${H - R} A ${R} ${R} 0 0 0 ${W - R} ${H} L -1 ${H + 1} Z")`;
}

/**
 * el と全子孫の描画上の右端・下端（ローカル座標）を返す。
 * .text-sticker は zigzag/flow レイアウトで .text-sticker-blocks が
 * left: 43rem 分はみ出すため、el.offsetWidth（CSS 上の width）だけでは
 * 実際に見えているコンテンツの右端・下端を表せない。sticker-position.js の
 * getVisualRight と同じ考え方で実測する。
 */
function getContentBounds(el) {
  const rect = el.getBoundingClientRect();
  const scale = rect.width / el.offsetWidth || 1;
  let maxRight = rect.right;
  let maxBottom = rect.bottom;
  el.querySelectorAll('*').forEach((child) => {
    const r = child.getBoundingClientRect();
    if (r.right > maxRight) maxRight = r.right;
    if (r.bottom > maxBottom) maxBottom = r.bottom;
  });
  return {
    width: (maxRight - rect.left) / scale,
    height: (maxBottom - rect.top) / scale,
  };
}

/**
 * ステッカーを右下コーナーが円弧状に捲れた状態から貼り付けるアニメーション。
 * clip-path: path() の円弧と、左上からのスライドインを rAF ループで同期させる。
 * どちらも el 自身にかける。translate は el の transform: scale()（.text-sticker--large
 * の 1.2 / SP の 0.6 など）と独立して合成されつつ、その scale の影響は受けるため、
 * ローカル座標で計算したスライド距離がどの breakpoint でも見た目の比率通りに縮む。
 * ライブラリ不使用。
 */
// ステッカースピード
function stampSticker(el) {
  const DURATION = 1700;

  if (getComputedStyle(el).position === 'static') {
    el.style.position = 'relative';
  }

  const { width: W, height: H } = getContentBounds(el);
  const FOLD_START = W + H;

  // ステッカースライド距離（px）
  const SLIDE_X = W * 0.02;
  const SLIDE_Y = H * 0.02;

  // 完全に隠れた初期状態を即座にセット（opacity フェードインより前に clip-path で隠す）
  el.style.clipPath = curlClipPath(W, H, FOLD_START);
  el.style.translate = `${-SLIDE_X}px ${-SLIDE_Y}px`;

  const startTime = performance.now();

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function step(now) {
    const t = Math.min((now - startTime) / DURATION, 1);
    const progress = easeOutCubic(t);
    const fold = FOLD_START * (1 - progress);
    el.style.clipPath = fold > 0.5 ? curlClipPath(W, H, fold) : '';
    el.style.translate = `${-SLIDE_X * (1 - progress)}px ${-SLIDE_Y * (1 - progress)}px`;

    if (t < 1) {
      requestAnimationFrame(step);
    } else {
      el.style.clipPath = '';
      el.style.translate = '';
    }
  }

  requestAnimationFrame(step);
}

/** .text-fit-text の中身を1文字ずつ fx-split-char に分解する */
function splitTextHold(el) {
  if (!el || el.dataset.fxSplitReady === '1') return;
  const text = (el.textContent || '').trim();
  if (!text) return;

  el.textContent = '';
  const row = document.createElement('span');
  row.className = 'fx-split-row';
  Array.from(text).forEach((char, i) => {
    const span = document.createElement('span');
    span.className = 'fx-split-char';
    span.style.setProperty('--i', String(i));
    span.textContent = char;
    row.appendChild(span);
  });
  el.appendChild(row);
  el.classList.add('fx-split-text-hold');
  el.dataset.fxSplitReady = '1';
}

// text-fit の文字アニメーションが開始してから、見た目上ほぼ止まって見えるまでの時間（ms）
const STICKER_START_DELAY_MS = 1200;

if (document.body.classList.contains('home')) {
  const header        = document.querySelector('.header');
  const taglineEl     = document.querySelector('.mv .tagline');
  const universityEl  = document.querySelector('.mv .university');
  const catchcopyEl   = document.querySelector('.mv .catchcopy');
  const slideTextEl   = document.querySelector('.mv .slide-text');
  const textFitEl     = document.querySelector('.mv .text-fit');
  const textFitTextEl = document.querySelector('.mv .text-fit .text-fit-text');
  const stickerEl     = document.querySelector('.mv-sticker');

  // プリステート設定
  const headerWrap = wrapHeaderIntroLine(header);
  if (headerWrap) headerWrap.classList.add('is-intro-pre');
  if (textFitEl) textFitEl.classList.add('is-intro-pre'); // text-fit 全体を隠す
  if (stickerEl) stickerEl.classList.add('is-sticker-intro-pre'); // ステッカーを縮小・回転で隠す

  const taglineLines = wrapLines(taglineEl);
  taglineLines.forEach((line) => line.classList.add('is-intro-pre'));

  const universityLines = wrapLines(universityEl);
  universityLines.forEach((line) => line.classList.add('is-intro-pre'));

  wrapIntroLine(catchcopyEl);
  if (catchcopyEl) catchcopyEl.classList.add('is-intro-pre');

  wrapIntroLine(slideTextEl);
  if (slideTextEl) slideTextEl.classList.add('is-intro-pre');

  document.fonts.ready.then(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!header) return;

        // text-fit.js のフィッティング完了後に文字分解 + split プリステート付与
        splitTextHold(textFitTextEl);
        if (textFitTextEl) textFitTextEl.classList.add('is-split-intro-pre');

        // ヘッダーアニメーション開始
        if (headerWrap) headerWrap.classList.remove('is-intro-pre');

        const STAGGER_MS = 150;   // 各行の間隔
        const OVERLAP_MS = 50;   // グループ間のオーバーラップ（前グループが終わる前に次が始まる）

        // ヘッダーアニメーションの途中から tagline を順次表示
        const TAGLINE_START_MS = 150;
        taglineLines.forEach((line, i) => {
          setTimeout(() => line.classList.remove('is-intro-pre'), TAGLINE_START_MS + i * STAGGER_MS);
        });

        // tagline と重なるように university を順次表示
        const UNIVERSITY_START_MS = TAGLINE_START_MS + taglineLines.length * STAGGER_MS + OVERLAP_MS;
        universityLines.forEach((line, i) => {
          setTimeout(() => line.classList.remove('is-intro-pre'), UNIVERSITY_START_MS + i * STAGGER_MS);
        });

        // university と重なるように catchcopy と slide-text を同時表示
        const CATCHCOPY_START_MS = UNIVERSITY_START_MS + universityLines.length * STAGGER_MS + OVERLAP_MS;
        setTimeout(() => {
          if (catchcopyEl) catchcopyEl.classList.remove('is-intro-pre');
          if (slideTextEl) slideTextEl.classList.remove('is-intro-pre');
        }, CATCHCOPY_START_MS);

        // catchcopy の少し後に text-fit を Split アニメーションで表示
        const TEXT_FIT_START_MS = CATCHCOPY_START_MS + 150;
        setTimeout(() => {
          if (textFitEl) textFitEl.classList.remove('is-intro-pre');
          if (textFitTextEl) textFitTextEl.classList.remove('is-split-intro-pre');

          setTimeout(() => {
            if (!stickerEl) return;
            // transition なしで opacity を瞬時に確定（clip-path が隠してくれるのでフェードイン不要）
            stickerEl.style.transition = 'none';
            stickerEl.classList.remove('is-sticker-intro-pre');
            requestAnimationFrame(() => {
              stickerEl.style.transition = '';
              const textStickerEl = stickerEl.querySelector('.text-sticker');
              stampSticker(textStickerEl || stickerEl);
            });
          }, STICKER_START_DELAY_MS);
        }, TEXT_FIT_START_MS);
      });
    });
  });
}
